import { render, staticRenderFns } from "./CheckoutOrderSidebar.vue?vue&type=template&id=1dae1d3e"
import script from "./CheckoutOrderSidebar.vue?vue&type=script&lang=js"
export * from "./CheckoutOrderSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports